import forcyteService from './ForcyteService'

const BASE_URL = 'donor-portal/v2'

class ChairpersonService {
  async login(formData) {
    return forcyteService.post(`${BASE_URL}/chairperson/login`, formData)
  }

  async getCurrentChairperson() {
    return forcyteService.get(`${BASE_URL}/chairperson/me`)
  }

  async logout() {
    return forcyteService.post(`${BASE_URL}/chairperson/logout`)
  }

  async resetPassword(formData) {
    return forcyteService.post(
      `${BASE_URL}/chairperson/reset-password`,
      formData
    )
  }

  async requestMagicLink(formData) {
    return forcyteService.post(
      `${BASE_URL}/chairperson/request-magic-link`,
      formData
    )
  }

  async getUpcomingDrives(accountId) {
    return forcyteService.get(`${BASE_URL}/chairperson/upcoming-drives`, {
      params: { account_id: accountId },
    })
  }

  async getPastDrives(accountId, page = 1, limit = 3) {
    return forcyteService.get(`${BASE_URL}/chairperson/past-drives`, {
      params: { account_id: accountId, page, limit },
    })
  }

  async getDriveResults(driveId, accountId) {
    return forcyteService.get(
      `${BASE_URL}/chairperson/drives/${driveId}/results`,
      {
        params: { account_id: accountId },
      }
    )
  }

  async getDriveDonors(driveId, accountId, limit = 3) {
    return forcyteService.get(
      `${BASE_URL}/chairperson/drives/${driveId}/donors`,
      {
        params: { account_id: accountId, limit },
      }
    )
  }

  async getDriveDonorsAccountDonors(driveId, accountId, query = {}) {
    return forcyteService.get(
      `${BASE_URL}/chairperson/drives/${driveId}/donors/account-donors`,
      { params: { account_id: accountId, ...query } }
    )
  }

  async getDriveDonorsScheduledAppointments(driveId, accountId, query = {}) {
    return forcyteService.get(
      `${BASE_URL}/chairperson/drives/${driveId}/donors/scheduled-appointments`,
      { params: { account_id: accountId, ...query } }
    )
  }

  async getDriveDonorsDriveAttendees(driveId, accountId, query = {}) {
    return forcyteService.get(
      `${BASE_URL}/chairperson/drives/${driveId}/donors/drive-attendees`,
      { params: { account_id: accountId, ...query } }
    )
  }

  async getDriveDonorsEmailComposeContext(driveId, accountId) {
    return forcyteService.get(
      `${BASE_URL}/chairperson/drives/${driveId}/donors/email/compose-context`,
      { params: { account_id: accountId } }
    )
  }

  async previewDriveDonorsEmailRecipients(driveId, accountId, body) {
    return forcyteService.post(
      `${BASE_URL}/chairperson/drives/${driveId}/donors/email/recipients/preview`,
      body,
      { params: { account_id: accountId } }
    )
  }

  async sendDriveDonorsEmail(driveId, accountId, body) {
    return forcyteService.post(
      `${BASE_URL}/chairperson/drives/${driveId}/donors/email/send`,
      body,
      { params: { account_id: accountId } }
    )
  }

  async sendDriveDonorsTestEmail(driveId, accountId, body) {
    return forcyteService.post(
      `${BASE_URL}/chairperson/drives/${driveId}/donors/email/test`,
      body,
      { params: { account_id: accountId } }
    )
  }

  async exportDriveDonorsExcel(driveId, accountId) {
    return forcyteService.get(
      `${BASE_URL}/chairperson/drives/${driveId}/donors/export`,
      { params: { account_id: accountId }, responseType: 'blob' }
    )
  }

  async exportDriveSummaryPdf(driveId, accountId) {
    return forcyteService.get(
      `${BASE_URL}/chairperson/drives/${driveId}/summary/export`,
      { params: { account_id: accountId }, responseType: 'blob' }
    )
  }

  async checkDriveAccess(driveId) {
    return forcyteService.get(`${BASE_URL}/chairperson/drive-access`, {
      params: { drive_id: driveId },
    })
  }

  async getDonorSchedule(driveId) {
    return forcyteService.get(`${BASE_URL}/chairperson/donor-schedule`, {
      params: { drive_id: driveId },
    })
  }

  async cancelAppointment(appointmentId) {
    return forcyteService.delete(
      `${BASE_URL}/chairperson/appointment/${appointmentId}`
    )
  }

  async searchDonors(searchText, limit = 10, page = 1, accountId = null) {
    const params = { search_text: searchText, limit, page }
    if (accountId) params.account_id = accountId
    return forcyteService.get(`${BASE_URL}/chairperson/donors/search`, {
      params,
    })
  }

  async scheduleDonor(donorId, slotId, notifyDonor = false) {
    return forcyteService.post(`${BASE_URL}/chairperson/schedule-donor`, {
      donor_id: donorId,
      slot_id: slotId,
      notify_donor: notifyDonor,
    })
  }

  async scheduleGuest(payload) {
    return forcyteService.post(
      `${BASE_URL}/chairperson/schedule-guest`,
      payload
    )
  }
}

const chairpersonService = new ChairpersonService()
export default chairpersonService
